import { Skeleton, Stack } from "@chakra-ui/react";

export default function ChatLoading() {
  return (
    <Stack>
         <Skeleton height='45px' />
        <Skeleton height='45px' />
        <Skeleton height='45px' />
        <Skeleton height='45px' />
        <Skeleton height='45px' />
        <Skeleton height='45px' />
        <Skeleton height='45px' />
        <Skeleton height='45px' />
    </Stack>
  )
}
